module.exports = __webpack_public_path__ + "img/icon-restaurant-pos.0f8b6b47.png";